<template>
  <div class="Flavour" :class="classes">
    <div class="Flavour__background"></div>
    <Page>
      <div v-if="theme" class="Flavour__content">
        <transition name="u-fade-in">
          <img
            v-if="show.logo"
            class="Flavour__logo"
            alt="The Glenlivet Spectra Flavour"
            :src="require(`../assets/flavour-${theme}-logo.png`)"
          />
        </transition>
        <div class="Flavour__sliders">
          <transition name="u-fade-in">
            <p v-if="show.intro" class="Flavour__intro">
              What was their intensity?
            </p>
          </transition>
          <transition name="u-fade-in">
            <div v-if="show.rangeSliders.one" class="Flavour__slider">
              <range-slider
                :theme="theme"
                v-model="flavoursScores.one"
                :label-text="flavoursParamToArray()[0]"
              />
            </div>
          </transition>
          <transition name="u-fade-in">
            <div v-if="show.rangeSliders.two" class="Flavour__slider">
              <range-slider
                :theme="theme"
                v-model="flavoursScores.two"
                :label-text="flavoursParamToArray()[1]"
              />
            </div>
          </transition>
          <transition name="u-fade-in">
            <div v-if="show.rangeSliders.three" class="Flavour__slider">
              <range-slider
                :theme="theme"
                v-model="flavoursScores.three"
                :label-text="flavoursParamToArray()[2]"
              />
            </div>
          </transition>
        </div>
        <transition name="u-fade-in">
          <base-button v-if="show.cta" :theme="theme" @click="onNext" wide
            >Next</base-button
          >
        </transition>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from '../components/Page'
import BaseButton from '../components/BaseButton'
import RangeSlider from '../components/RangeSlider'
import { flavourMixin } from '../mixins/flavourMixin'
import { audioMixin } from '../mixins/audioMixin'

export default {
  components: { RangeSlider, BaseButton, Page },
  mixins: [flavourMixin, audioMixin],
  data() {
    return {
      transitionDuration: 0,
      transitionDelay: 100,
      show: {
        logo: false,
        intro: false,
        rangeSliders: {
          one: false,
          two: false,
          three: false
        },
        cta: false
      },
      savedState: {}
    }
  },
  mounted() {
    this.savedState = JSON.parse(sessionStorage.getItem('glenlivet_state'))
    this.startAnimation()

    this.playSound('intensity')
  },
  methods: {
    startAnimation() {
      setTimeout(() => {
        this.show.logo = true
      }, this.transitionDuration)
      setTimeout(() => {
        this.show.intro = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.rangeSliders.one = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.rangeSliders.two = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.rangeSliders.three = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.cta = true
      }, (this.transitionDuration += this.transitionDelay))
    },
    onNext() {
      let audioName = 'result-two-more-to-try'

      this.$log.info('this.savedState', this.savedState)

      // Update audio track if the user has already selected a bottle
      if (this.savedState) {
        const savedStateLength = Object.keys(this.savedState).length

        this.$log.info('savedStateLength', savedStateLength)
        if (savedStateLength === 1) {
          audioName = 'result-one-more-to-try'
        }

        if (savedStateLength === 2) {
          audioName = 'result-share-your-score'
        }

        if (savedStateLength === 3) {
          audioName = 'result-share-your-score'
        }
      }

      this.playSound(audioName)

      // Go to result page (radar chart)
      this.$router.push({
        path: 'result',
        query: {
          theme: this.theme,
          flavours: this.flavoursParamToArray().join(), // convert to string so we can use in URL
          flavour_scores: `${this.flavoursScores.one},${this.flavoursScores.two},${this.flavoursScores.three}`
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';
@import '../scss/flavour.scss';
</style>
